// extracted by mini-css-extract-plugin
export var errorsContainer = "_ss-1";
export var link = "_ss-0";